import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { ModalWithSidebar } from '@livable/saas-react-components';
import { LoaderButton } from '@livable/saas-react-components';
import UpdatesTab from './UpdatesTab';
import NewFeeStructureTab from './NewFeeStructureTab';
import ConfirmTab from './ConfirmTab';
export default function BatchFeeUpdateModal(props) {
  const _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? undefined : _props$trigger,
    _props$tenantsList = props.tenantsList,
    tenantsList = _props$tenantsList === void 0 ? undefined : _props$tenantsList,
    _props$buildingsList = props.buildingsList,
    buildingsList = _props$buildingsList === void 0 ? undefined : _props$buildingsList;
  const tabs = [{
    label: 'Updates to...',
    name: 'updates'
  }, {
    label: 'New fee structure',
    name: 'new-fee-structure'
  }, {
    label: 'Confirm',
    name: 'confirm'
  }];
  const _useState = useState(tabs[0].name),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };
  const getModalRightButton = () => {
    if (selectedTab === 'updates') {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        onClick: () => setSelectedTab('new-fee-structure'),
        'custom-attribute': '51-batch-fee-update-modal'
      }, "Next: New fee structure");
    }
    if (selectedTab === 'new-fee-structure') {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        onClick: () => setSelectedTab('confirm'),
        'custom-attribute': '52-batch-fee-update-modal'
      }, "Next: Confirm");
    }
    return /*#__PURE__*/React.createElement(LoaderButton, {
      loadingText: "Confirming...",
      buttonText: "Confirm new fees",
      successText: "Confirmed successfully",
      errorText: "Confirming failed",
      status: "success"
    });
  };
  return /*#__PURE__*/React.createElement(ModalWithSidebar, {
    trigger: trigger,
    title: tenantsList ? '8558 Green Rd. fee update' : 'Batch fee update',
    tabs: tabs,
    selectedTab: selectedTab,
    handleTabChange: handleTabChange,
    rightButton: getModalRightButton(),
    'custom-attribute': '53-batch-fee-update-modal'
  }, selectedTab === 'updates' && /*#__PURE__*/React.createElement(UpdatesTab, {
    tenantsList: tenantsList,
    buildingsList: buildingsList
  }), selectedTab === 'new-fee-structure' && /*#__PURE__*/React.createElement(NewFeeStructureTab, null), selectedTab === 'confirm' && /*#__PURE__*/React.createElement(ConfirmTab, {
    tenantsList: tenantsList,
    buildingsList: buildingsList
  }));
}
BatchFeeUpdateModal.propTypes = {
  trigger: PropTypes.node,
  tenantsList: PropTypes.arrayOf(PropTypes.string),
  buildingsList: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
    tenants: PropTypes.arrayOf(PropTypes.string)
  }))
};